<template>
  <Dialog v-model:visible="showModal" class="w-3/5 d2-dialog-mobile-full bg-white shadow rounded-xl" :modal="true" style="position:relative">
    <loading :active="!showPayStatus"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <template #header>
      <div class="w-full d2-dialog-header-title">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_title_text']}}</div>
    </template>
    <div class="text-gray-700 text-center font-mono flex flex-wrap justify-center d2-change-plan-banner my-2" :class="[bannerColor == 'fb' ? 'bg-plan-A' : 'bg-tiktok-plan-A']">
      <div class="text-white mt-6 pl-12">
        <p class="d2-change-plan-title">{{planCheckData.title}}</p>
      </div>
    </div>
    <div class="d2-change-plan-content py-8">
      <ul class="flex-1 space-y-2 d2-dialog-content-mx text-gray-500 dark:text-gray-400">
        <li v-for="(item, index) in planCheckData.description">
          <i class="pi pi-check pr-2 text-green-400"></i>
          <span v-html="item"></span>
        </li>
        <li><span class="cursor-pointer text-blue-500 underline" @click="showDisclaimer">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_service_text']}}</span></li>
      </ul>
      <ul v-if="planCheckData.PeriodAmount >= 5" class="flex-1 space-y-4 d2-dialog-content-mx text-gray-700 dark:text-gray-400">
        <li class="text-2xl font-semibold">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_payment_text']}}</li>
        <li>
          <p class="text-gray-500 font-medium">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_describe_date_text']}}：{{planCheckData.expire_time}}</p>
          <p class="text-gray-500 font-normal">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_describe_price_text']}} {{planCheckData.label_currency}} {{planCheckData.label_PeriodAmount}}</p>
          <p class="text-gray-500 font-normal">{{ subscriptionText }}</p>
        </li>
        <li v-if="planCheckData.haveBind && selectedPayMethod === 'credit'">
          <p class="font-medium">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_bind_card_credit_text']}}</p>
          <p class="text-gray-500 font-normal">
            <span>{{planCheckData.card_no}}</span>
          </p>
        </li>
        <li v-if="false">
          <p class="font-medium">發票統一編號</p>
          <p class="text-gray-500 font-normal">245646377553</p>
        </li>
        <li v-if="showPayMethodSelector">
          <p class="font-medium">選擇付款方式</p>
          <div class="mt-2 space-y-2">
            <label class="flex items-center cursor-pointer">
              <input type="radio" v-model="selectedPayMethod" value="credit" class="mr-2">
              <span class="text-gray-500 font-normal">信用卡</span>
            </label>
            <label class="flex items-center cursor-pointer">
              <input type="radio" v-model="selectedPayMethod" value="atm" class="mr-2">
              <span class="text-gray-500 font-normal">ATM 虛擬帳號轉帳</span>
            </label>
          </div>
          <p v-if="selectedPayMethod === 'atm'" class="mt-2 text-sm text-orange-500">
            系統將產生虛擬帳號，請於 3 天內完成轉帳。逾期帳號將自動失效。
          </p>
        </li>
      </ul>
      <ul v-if="planCheckData.PeriodAmount < 5 || (planCheckData.plan_type == 'C' && !planCheckData.payAgain)" class="flex-1 space-y-4 d2-dialog-content-mx text-gray-700 dark:text-gray-400">
        <li class="text-2xl font-semibold">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_customized_title']}}</li>
        <li>
          <p class="text-gray-500 font-medium">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_customized_info_1']}}</p>
          <p class="text-gray-500 font-normal">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_customized_info_2']}}</p>
        </li>
      </ul>
    </div>
    <template #footer>
      <div class="w-full d2-btn-row" style="justify-content: flex-end; padding-top: 12px; border-top: 1px solid rgba(0,0,0,0.06);">
        <button
          v-if="(planCheckData.use_plan_id == planCheckData.check_plan_id && planCheckData.is_expired == false) || (planCheckData.use_plan_id > planCheckData.check_plan_id) || planCheckData.PeriodAmount == -1 || planCheckData.PeriodAmount == 0"
          class="d2-btn-ghost"
          @click="showModal=false">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_card_close_button_text']}}</button>
        <button
          v-else
          class="d2-btn-ghost"
          @click="showModal=false">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_card_cancel_button_text']}}</button>
        <button
          v-if="planCheckData.use_plan_id < planCheckData.check_plan_id && planCheckData.PeriodAmount != -1 && planCheckData.PeriodAmount != 0"
          class="d2-btn d2-btn-yellow"
          @click="toPay()">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_card_pay_button_text']}}
        </button>
        <button
          v-if="planCheckData.use_plan_id == planCheckData.check_plan_id && planCheckData.is_expired == true  && planCheckData.PeriodAmount != -1 && planCheckData.PeriodAmount != 0"
          class="d2-btn d2-btn-yellow"
          @click="toPayAgain()">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_card_payagain_button_text']}}
        </button>
      </div>
    </template>
  </Dialog>

  <DisclaimerDialog :list="details" v-bind:lang="lang" v-model:show="showDetail" />
  
  <!-- 發票資訊彈窗 -->
  <InvoiceDialog
    v-bind:lang="lang"
    v-bind:invoiceData="invoiceData"
    v-model:show="showInvoiceModal"
    @invoiceSaved="onInvoiceSaved"
  />

  <!-- ECPay 付款彈窗 -->
  <Dialog v-model:visible="showEcpayModal" class="w-4/5 lg:w-3/5 bg-white shadow rounded-xl" :modal="true" :closable="true">
    <template #header>
      <div class="w-full text-gray-900 font-semibold">信用卡付款</div>
    </template>
    <div class="py-4">
      <div id="ECPayPayment" style="min-height: 400px;"></div>
    </div>
    <template #footer>
      <div class="w-full flex justify-end gap-2 py-2">
        <button
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-2 text-gray-500 transition duration-300 border border-gray-300"
          @click="showEcpayModal = false"
        >
          取消
        </button>
        <button
          class="bg-blue-500 hover:bg-blue-600 focus:outline-none rounded-xl px-4 py-2 text-white transition duration-300"
          :disabled="isSubmittingPayment"
          @click="submitEcpayPayment"
        >
          <span v-if="isSubmittingPayment">處理中...</span>
          <span v-else>確認付款</span>
        </button>
      </div>
    </template>
  </Dialog>
</template>

<script>
  import Dialog from 'primevue/dialog';
  import DisclaimerDialog from "./DisclaimerDialog.vue";
  import InvoiceDialog from "./InvoiceDialog.vue";
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'ChangePlanDialog',
    components: {
      Dialog,
      DisclaimerDialog,
      InvoiceDialog,
      Swal,
      Loading
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      planCheck:{
        type:Object,
      },
      bannerColor: {
        type: String
      },
      memberId: {
        type: Number,
      },
      lang: {
        type: Object
      },
      borderStyle:{
        type: Number
      }
    },
    data() {
      return {
        showPayStatus: true,
        showDetail: false,
        showInvoiceModal: false,
        showEcpayModal: false,
        invoiceData: {
          identifier: '',
          name: '',
          address: '',
          mobile: '',
          email: ''
        },
        pendingPaymentData: null, // 暫存待付款資料
        selectedPayMethod: 'credit', // credit / atm
        ecpaySdkLoaded: false,
        isSubmittingPayment: false
      }
    },
    methods: {
      // 檢查發票資訊
      async checkInvoiceData() {
        try {
          const response = await axios.post('https://www.autoturn.net/api/data/invoice_check.php', Qs.stringify({
            s_code: this.$route.params.id
          }))

          if (response.data.status === 'success') {
            this.invoiceData = response.data.invoiceData
            return response.data.hasInvoiceData
          }
          return false
        } catch (error) {
          console.error('檢查發票資訊失敗:', error)
          return false
        }
      },

      // 發票資訊儲存完成後的回調
      onInvoiceSaved() {
        this.showInvoiceModal = false
        // 繼續執行付款流程
        if (this.pendingPaymentData) {
          if (this.pendingPaymentData.payMethod === 'atm') {
            this.createAtmOrder(this.pendingPaymentData, this.pendingPaymentData.payType || 'new')
          } else {
            this.proceedToPayment(this.pendingPaymentData)
          }
        }
      },

      // 取得 ECPay Token 並顯示付款畫面
      async getEcpayToken(paymentData) {
        this.showPayStatus = false

        try {
          const response = await axios.post('https://www.autoturn.net/udnapi/account_info/create_hidden_data_v3.php', Qs.stringify({
            member_id: paymentData.memberId,
            currency: paymentData.currency,
            price: paymentData.price,
            plan_title: paymentData.planTitle,
            plan_id: paymentData.planId,
            hash: this.$route.params.id
          }))

          this.showPayStatus = true

          if (response.data.status === 'success') {
            // 載入 ECPay SDK 並顯示付款畫面
            this.loadEcpaySdk(response.data.data)
          } else {
            Swal.fire({
              icon: 'error',
              title: '付款失敗',
              text: response.data.info
            })
          }
        } catch (error) {
          this.showPayStatus = true
          console.error('取得 Token 失敗:', error)
          Swal.fire({
            icon: 'error',
            title: '付款失敗',
            text: '無法連線到付款伺服器，請稍後再試'
          })
        }
      },

      // 載入 ECPay SDK
      loadEcpaySdk(data) {
        // 先顯示付款彈窗
        this.showEcpayModal = true

        // 檢查是否已載入 SDK
        if (this.ecpaySdkLoaded) {
          this.initEcpayPayment(data.Token)
          return
        }

        // 動態載入 jQuery (如果尚未載入)
        if (!window.jQuery) {
          const jqueryScript = document.createElement('script')
          jqueryScript.src = 'https://code.jquery.com/jquery-3.5.1.min.js'
          jqueryScript.onload = () => {
            this.loadEcpaySdkScript(data)
          }
          document.head.appendChild(jqueryScript)
        } else {
          this.loadEcpaySdkScript(data)
        }
      },

      // 載入 ECPay SDK Script
      loadEcpaySdkScript(data) {
        const script = document.createElement('script')
        script.src = data.SdkUrl
        script.onload = () => {
          this.ecpaySdkLoaded = true
          this.initEcpayPayment(data.Token)
        }
        script.onerror = () => {
          Swal.fire({
            icon: 'error',
            title: '載入失敗',
            text: '無法載入付款元件，請重新整理頁面後再試'
          })
          this.showEcpayModal = false
        }
        document.head.appendChild(script)
      },

      // 初始化 ECPay 付款畫面
      initEcpayPayment(token) {
        // 等待 DOM 更新
        this.$nextTick(() => {
          // 確保 DOM 元素存在
          const container = document.getElementById('ECPayPayment')
          if (!container) {
            console.error('ECPay 容器元素不存在')
            return
          }

          if (window.ECPay) {
            // Step 1: ECPay.initialize(ServerType, IsLoading, callBack)
            // ServerType: 'Stage' 測試環境, 'Prod' 正式環境
            // IsLoading: 1 顯示等待畫面
            const serverType = 'Prod' // 測試環境

            window.ECPay.initialize(serverType, 1, function(errMsg) {
              if (errMsg) {
                console.error('ECPay 初始化錯誤:', errMsg)
                Swal.fire({
                  icon: 'error',
                  title: '付款元件初始化失敗',
                  text: errMsg
                })
                return
              }
              console.log('ECPay SDK 初始化成功')

              // Step 2: ECPay.addBindingCard(Token, Language, callBack)
              // 取得綁定信用卡畫面
              var lang = window.ECPay.Language.zhTW // 繁體中文

              window.ECPay.addBindingCard(token, lang, function(bindErrMsg) {
                if (bindErrMsg) {
                  console.error('ECPay 綁定信用卡畫面錯誤:', bindErrMsg)
                  Swal.fire({
                    icon: 'error',
                    title: '載入付款畫面失敗',
                    text: bindErrMsg
                  })
                } else {
                  console.log('ECPay 綁定信用卡畫面載入成功')
                }
              })
            })
          } else {
            console.error('ECPay SDK 未載入')
          }
        })
      },

      // 執行付款流程
      async proceedToPayment(paymentData) {
        await this.getEcpayToken(paymentData)
      },

      // 建立 ATM 訂單
      async createAtmOrder(paymentData, payType = 'new') {
        this.showPayStatus = false

        try {
          const postData = {
            member_id: paymentData.memberId,
            plan_id: paymentData.planId,
            s_code: this.$route.params.id,
            route_type: this.$route.params.type,
            pay_type: payType
          }
          if (paymentData.upgradeAmount) {
            postData.upgrade_amount = paymentData.upgradeAmount
          }
          const response = await axios.post('https://www.autoturn.net/api/atm_create_order.php', Qs.stringify(postData))

          this.showPayStatus = true

          if (response.data.status === 'success') {
            // 注入 ECPay checkout 表單並自動提交導向綠界
            const div = document.createElement('div')
            div.innerHTML = response.data.html
            div.style.display = 'none'
            document.body.appendChild(div)
            const form = div.querySelector('form')
            if (form) {
              form.submit()
            }
          } else {
            Swal.fire({
              icon: 'error',
              title: 'ATM 訂單建立失敗',
              text: response.data.info
            })
          }
        } catch (error) {
          this.showPayStatus = true
          console.error('ATM 訂單建立失敗:', error)
          Swal.fire({
            icon: 'error',
            title: 'ATM 訂單建立失敗',
            text: '無法連線到伺服器，請稍後再試'
          })
        }
      },

      // 提交 ECPay 付款
      submitEcpayPayment() {
        if (!window.ECPay) {
          Swal.fire({
            icon: 'error',
            title: '錯誤',
            text: '付款元件尚未載入'
          })
          return
        }

        // 列出 ECPay 可用方法供除錯
        console.log('ECPay 可用方法:', Object.keys(window.ECPay))

        this.isSubmittingPayment = true
        const self = this

        // ECPay 站內付 2.0 使用 getBindCardPayToken() 方法提交綁卡表單
        if (typeof window.ECPay.getBindCardPayToken === 'function') {
          window.ECPay.getBindCardPayToken(function(paymentInfo, errMsg) {
            if (errMsg) {
              self.isSubmittingPayment = false
              console.error('ECPay 綁卡錯誤:', errMsg)
              Swal.fire({
                icon: 'error',
                title: '付款失敗',
                text: errMsg
              })
              return
            }

            if (paymentInfo) {
              console.log('ECPay 綁卡成功，paymentInfo:', paymentInfo)
              // 呼叫後端 API 完成付款
              self.completeBindCardPayment(paymentInfo)
            }
          })
        } else {
          this.isSubmittingPayment = false
          console.error('ECPay.getBindCardPayToken 方法不存在')
          Swal.fire({
            icon: 'warning',
            title: 'ECPay SDK 錯誤',
            html: `<p>找不到 getBindCardPayToken 方法</p>`
          })
        }
      },

      // 完成綁卡付款
      async completeBindCardPayment(paymentInfo) {
        try {
          Swal.fire({
            title: '處理中',
            text: '正在處理您的付款，請稍候...',
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading()
            }
          })

          const response = await axios.post('https://www.autoturn.net/udnapi/account_info/create_bindcard_payment.php', Qs.stringify({
            bind_card_pay_token: paymentInfo.BindCardPayToken,
            merchant_trade_no: paymentInfo.MerchantTradeNo,
            member_id: this.planCheckData.memberId
          }))

          this.isSubmittingPayment = false

          if (response.data.status === 'success') {
            if (response.data.need3D && response.data.threeDURL) {
              window.location.href = response.data.threeDURL
              return
            }

            this.showEcpayModal = false
            Swal.fire({
              icon: 'success',
              title: '付款成功',
              text: '您的付款已完成！',
              confirmButtonText: '確定'
            }).then(() => {
              window.location.reload()
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: '付款失敗',
              text: response.data.info || '付款處理失敗'
            })
          }
        } catch (error) {
          this.isSubmittingPayment = false
          console.error('完成付款失敗:', error)
          Swal.fire({
            icon: 'error',
            title: '付款失敗',
            text: '無法連線到付款伺服器'
          })
        }
      },

      async toPay(){
        console.log('this.planCheckData.memberId');
        console.log(this.planCheckData.memberId);
        console.log('this.planCheckData.payStatus');
        console.log(this.planCheckData.payStatus);

        // 準備付款資料
        const paymentData = {
          memberId: this.planCheckData.memberId,
          currency: this.planCheckData.currency,
          price: this.planCheckData.PeriodAmount,
          planTitle: this.planCheckData.title,
          planId: this.planCheckData.planId
        }

        if(this.planCheckData.payStatus == 'free' || this.planCheckData.haveBind == false){
          // 首次付款：檢查發票資訊
          const hasInvoice = await this.checkInvoiceData()

          if (!hasInvoice) {
            // 沒有發票資訊，顯示發票填寫彈窗
            this.pendingPaymentData = { ...paymentData, payMethod: this.selectedPayMethod }
            this.showInvoiceModal = true
            return
          }

          // 有發票資訊，根據付款方式進行付款
          if (this.selectedPayMethod === 'atm') {
            await this.createAtmOrder(paymentData)
          } else {
            await this.proceedToPayment(paymentData)
          }

        } else {
          // 已綁卡用戶：升級方案
          let hash = this.$route.params.id;
          let type = this.$route.params.type;

          axios
            .post('https://www.autoturn.net/api/payment_difference.php', Qs.stringify({
              s_code: this.$route.params.id,
              member_id: this.planCheckData.memberId,
              currency: this.planCheckData.currency,
              price: this.planCheckData.PeriodAmount,
              plan_title: this.planCheckData.title,
              plan_id: this.planCheckData.planId,
            }))
            .then((response) => {
              // if(response.data.status == 'success'){
                // this.$swal(response.data.info);
                // this.showModal = false;
                // this.isEdit = false;
              // }
              let update_price = response.data.amount
              Swal.fire({
                title: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['payment_difference']['swal_title'],
                html: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['payment_difference']['swal_html_a']+'<span style="color:red; font-weight:bold;">'+this.planCheckData.title+'</span>'+this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['payment_difference']['swal_html_b']+'<span style="color:red; font-weight:bold;">'+this.planCheckData.currency+' $'+ update_price +'</span>'+this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['payment_difference']['swal_html_c'],
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['payment_difference']['yes_button'],
                cancelButtonText: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['payment_difference']['no_button'],
              }).then((result) => {
                if (result.isConfirmed) {
                  // ATM 差額升級
                  if (this.selectedPayMethod === 'atm' && update_price > 0) {
                    this.createAtmOrder({
                      memberId: this.planCheckData.memberId,
                      planId: this.planCheckData.planId,
                      upgradeAmount: update_price
                    }, 'upgrade')
                    return
                  }

                  // 信用卡差額扣款（原有流程）
                  this.showPayStatus = false

                  axios
                    .post('https://www.autoturn.net/api/plan_update.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      member_id: this.planCheckData.memberId,
                      currency: this.planCheckData.currency,
                      price: update_price,
                      plan_title: this.planCheckData.title,
                      plan_id: this.planCheckData.planId,
                    }))
                    .then((puResponse) => {
                      // if(puResponse.data.status == 'success'){
                        this.showPayStatus = true

                        Swal.fire({
                          icon: puResponse.data.status,
                          title: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['plan_update']['swal_title'],
                          text: puResponse.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['plan_update']['confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            window.location.href = "https://private.autoturn.net/"+type+"/"+hash;
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            window.location.href = "https://private.autoturn.net/"+type+"/"+hash;
                          }
                          if (result.dismiss === Swal.DismissReason.timer) {
                            window.location.href = "https://private.autoturn.net/"+type+"/"+hash;
                          }
                        })
                      // }

                    });
                }
              })

            });
        }

        // Swal.fire({
        //   title: "修改綁定信用卡",
        //   html: "您確定要修改綁定信用卡嗎？",
        //   icon: 'warning',
        //   showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   cancelButtonColor: '#d33',
        //   confirmButtonText: '是',
        //   cancelButtonText: '取消',
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     console.log(this.$route.params.id);

        //     // this.showModal=false;
        //   }
        // })
      },
      async toPayAgain(){
        // console.log('toPayAgain');
        // console.log(this.planCheckData.memberId);
        let hash = this.$route.params.id;
        let type = this.$route.params.type;

        // ATM 用戶續約
        if (this.selectedPayMethod === 'atm' || this.planCheckData.payMethod === 'atm') {
          const hasInvoice = await this.checkInvoiceData()
          if (!hasInvoice) {
            this.pendingPaymentData = {
              memberId: this.planCheckData.memberId,
              planId: this.planCheckData.planId,
              payMethod: 'atm',
              payType: 'renew'
            }
            this.showInvoiceModal = true
            return
          }
          await this.createAtmOrder({
            memberId: this.planCheckData.memberId,
            planId: this.planCheckData.planId
          }, 'renew')
          return
        }

        Swal.fire({
          title: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay_again']['swal_title'],
          html: '<span style="color:red; font-weight:bold;">'+this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay_again']['swal_html_a']+'</span>'+this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay_again']['swal_html_b'],
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay_again']['yes_button'],
          cancelButtonText: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay_again']['no_button'],
        }).then((result) => {
          if (result.isConfirmed) {
            // console.log(this.$route.params.id);
            this.showPayStatus = false

            axios
              .post('https://www.autoturn.net/api/pay_again.php', Qs.stringify({
                s_code: this.$route.params.id,
                member_id: this.planCheckData.memberId
              }))
              .then((puResponse) => {
                // if(puResponse.data.status == 'success'){
                  this.showPayStatus = true

                  Swal.fire({
                    icon: puResponse.data.status,
                    title: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay_again']['pay_again']['swal_title'],
                    text: puResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay_again']['pay_again']['confirm_button'],
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      window.location.href = "https://private.autoturn.net/"+type+"/"+hash;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      window.location.href = "https://private.autoturn.net/"+type+"/"+hash;
                    }
                    if (result.dismiss === Swal.DismissReason.timer) {
                      window.location.href = "https://private.autoturn.net/"+type+"/"+hash;
                    }
                  })
                // }

              });
          }
        })
      },
      showDisclaimer(){
        this.showDetail = true
      }
    },
    watch: {
      show(newVal) {
        if (newVal) {
          this.selectedPayMethod = (this.planCheckData && this.planCheckData.payMethod === 'atm') ? 'atm' : 'credit'
        }
      }
    },
    computed: {
      showModal: {
        get: function () {
          return this.show
        },
        set: function (value) {
          this.$emit('update:show', value)
        }
      },
      planCheckData: {
        get: function () {
          return this.planCheck
        },
        set: function (value) {
          this.$emit('update:planCheckData', value)
        }
      },
      showPayMethodSelector() {
        return this.planCheckData.PeriodAmount >= 5
      },
      subscriptionText() {
        const frequency = this.planCheckData.Frequency || 1;
        if (frequency === 3) {
          return this.lang['components']['Dialog']['ChangePlanDialog']['change_plan_describe_area_3_quarterly'] || '採自動訂閱制，每季自動續約';
        } else if (frequency === 12) {
          return this.lang['components']['Dialog']['ChangePlanDialog']['change_plan_describe_area_3_yearly'] || '採自動訂閱制，每年自動續約';
        } else {
          return this.lang['components']['Dialog']['ChangePlanDialog']['change_plan_describe_area_3'];
        }
      }
    }
  }
</script>

<style lang="scss" scope>

</style>